module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqBAMAAAA37dRoAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAYUExURUdwTK63x623x6+3x6+4yK64yK+6yK+5yEGlnV4AAAAHdFJOUwBAYSGjgucKBRi5AAAAeklEQVQoz2NgIBGwhiJAMEyQMb0cCQRARdmQBcsLoaLiQHapEgiEgVhIogVgFguQVYKsVhAExNFEEWBUdKiIMikhA0W8ycwYBRgQY1saNtESBnUsosXgVIYuWoAmag7lQWRhKZUFxbZiqCgzcg4oU4BnDEEEECY1qwEAkn/XlaBOC5oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/tab/yddht.png
// module id = WfTZ
// module chunks = 0